import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/storage'
import 'firebase/database'
import 'firebase/firestore'



export const firebaseApp = firebase.initializeApp({
    apiKey: process.env.VUE_APP_API_KEY,
    authDomain: process.env.VUE_APP_AUTH_DOMAIN,
    databaseURL: process.env.VUE_APP_DATABASE_URL,
    projectId: process.env.VUE_APP_PROJECT_ID,
    storageBucket: process.env.VUE_APP_STORAGE_BUCKET,
    messagingSenderId: process.env.VUE_APP_MESSAGING_SENDER_ID,
    appId: process.env.VUE_APP_API_ID,
    measurementId: process.env.VUE_APP_MEASUREMENT_ID
/*     apiKey: "AIzaSyCzEoGlPuHOcK4vHm_V5eap1idKYfsAAyU",
    authDomain: "greenpecas-99548.firebaseapp.com",
    databaseURL: "https://greenpecas-99548.firebaseio.com",
    projectId: "greenpecas-99548",
    storageBucket: "greenpecas-99548.appspot.com",
    messagingSenderId: "180004210534",
    appId: "1:180004210534:web:23c924521d960f3f386aa7",
    measurementId: "G-X7EENCEEDZ" */


})



export default function install (Vue){
    Object.defineProperty(Vue.prototype, '$firebase', {
        get(){
            return firebaseApp
        }
    })
} 